import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ICapexApplicationReport, ICapexReportSum, IDefectActDivision } from './interfaces';

export const getCapexReportList = (year: number, divisionId?: number) => (data: IDynamicTableParams) => {
  return instance()
    .post<ICapexApplicationReport[]>(
      divisionId ? `/capex/report/list/${year}/${divisionId}` : `/capex/report/list/${year}`,
      data,
    )
    .then((response) => response.data);
};

export const getCapexReportAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/capex/report/availableColumns')
    .then((response) => response.data);
};

export const getCapexReportAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/capex/report/availableGroupColumns')
    .then((response) => response.data);
};

export const downloadCapexReportByYear = (year: number) => {
  return instance()
    .get<Blob>('/capex/report/' + year, { responseType: 'blob' })
    .then((response) => response);
};

export const getCapexReportListSum = (year: number, divisionId?: number) => (data: IDynamicTableParams) => {
  return instance()
    .post<ICapexReportSum>(
      divisionId ? `/capex/report/listSum/${year}/${divisionId}` : `/capex/report/listSum/${year}`,
      data,
    )
    .then((response) => response.data);
};

export const getDefectActDivisionList = () => {
  return instance()
    .post<IDefectActDivision[]>(`/defectActDivision/listAllNotDeleted`)
    .then((response) => response.data);
};
